import { padStart } from 'lodash'

export default {
  computed: {
    yyyItems () {
      const yyy = []
      const current = new Date().getFullYear() - 1911
      for (let index = current; index >= 1; index--) {
        let y = padStart(index, 3, 0)
        yyy.push(y)
      }
      return yyy
    },
    yyyyItems () {
      const yyyy = []
      const current = new Date().getFullYear()
      for (let index = current; index >= 1911; index--) {
        let y = padStart(index, 4, 0)
        yyyy.push(y)
      }
      return yyyy
    }
  },

  methods: {
    mmItemsAD (yyyy) {
      const mm = []
      const y = parseInt(yyyy)
      const nowy = new Date().getFullYear()
      const nowm = new Date().getMonth() + 1
      const m = (nowy === y) ? nowm : 12
      for (let index = 1; index <= m; index++) {
        let m = padStart(index, 2, '0')
        mm.push(m)
      }
      return mm
    },
    ddItemsAD (yyyy, mm) {
      const y = parseInt(yyyy)
      const m = parseInt(mm)
      const nowy = new Date().getFullYear()
      const nowm = new Date().getMonth() + 1
      const nowd = new Date().getDate()
      const d = (nowy === y && nowm === m) ? nowd : new Date(y, m, 0).getDate()
      const dd = []
      for (let index = 1; index <= d; index++) {
        let d = padStart(index, 2, '0')
        dd.push(d)
      }

      return dd
    },
    mmItems (yyy) {
      const mm = []
      const y = parseInt(yyy) + 1911
      const nowy = new Date().getFullYear()
      const nowm = new Date().getMonth() + 1
      const m = (nowy === y) ? nowm : 12
      for (let index = 1; index <= m; index++) {
        let m = padStart(index, 2, '0')
        mm.push(m)
      }
      return mm
    },
    ddItems (yyy, mm) {
      const y = parseInt(yyy) + 1911
      const m = parseInt(mm)
      const nowy = new Date().getFullYear()
      const nowm = new Date().getMonth() + 1
      const nowd = new Date().getDate()
      const d = (nowy === y && nowm === m) ? nowd : new Date(y, m, 0).getDate()
      const dd = []
      for (let index = 1; index <= d; index++) {
        let d = padStart(index, 2, '0')
        dd.push(d)
      }

      return dd
    },
    yyyItemsForReivew () {
      const yyy = []
      let underDate = new Date()
      underDate.setDate(underDate.getDate() - 4)
      const current = underDate.getFullYear() - 1911
      for (let index = current; index >= 1; index--) {
        let y = padStart(index, 3, 0)
        yyy.push(y)
      }
      return yyy
    },
    mmItemsForReivew (yyy) {
      const mm = []
      const y = parseInt(yyy) + 1911
      let underDate = new Date()
      underDate.setDate(underDate.getDate() - 4)
      const nowy = underDate.getFullYear()
      const nowm = underDate.getMonth() + 1
      const m = (nowy === y) ? nowm : 12
      for (let index = 1; index <= m; index++) {
        let m = padStart(index, 2, '0')
        mm.push(m)
      }
      return mm
    },
    ddItemsForReivew (yyy, mm) {
      const y = parseInt(yyy) + 1911
      const m = parseInt(mm)
      let underDate = new Date()
      underDate.setDate(underDate.getDate() - 4)
      const nowy = underDate.getFullYear()
      const nowm = underDate.getMonth() + 1
      const nowd = underDate.getDate()
      const d = (nowy === y && nowm === m) ? nowd : new Date(y, m, 0).getDate()
      const dd = []
      for (let index = 1; index <= d; index++) {
        let d = padStart(index, 2, '0')
        dd.push(d)
      }

      return dd
    }
  }
}
